// extracted by mini-css-extract-plugin
module.exports = {"SharePanel":"SharePanel_SharePanel__1hqTY","CloseButton":"SharePanel_CloseButton__30z2O","Feedback":"SharePanel_Feedback__16aMH","ShareButton":"SharePanel_ShareButton__331M0"};